module.exports = require('./helpers/bundle-url').getBundleURL('9ZlAP') + "AVALogoREV.487523c0.png";